import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import '../../css/styles.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const handleSmoothScroll = (elementId) => {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  // Enhanced navigation function that works across pages
  const handleNavigateToSection = (sectionId) => {
    // If we're not on the homepage, navigate to homepage first
    if (location.pathname !== '/') {
      navigate('/', { replace: true });
      // Wait for navigation to complete, then scroll
      setTimeout(() => {
        handleSmoothScroll(sectionId);
      }, 100);
    } else {
      // If already on homepage, just scroll
      handleSmoothScroll(sectionId);
    }
  };

  // Enhanced scroll effect with additional classes
  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      
      if (scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Handle scrolling when navigating with hash
  useEffect(() => {
    const hash = location.hash;
    if (hash) {
      // Remove the # from hash and scroll to element
      const elementId = hash.substring(1);
      setTimeout(() => {
        handleSmoothScroll(elementId);
      }, 100);
    }
  }, [location]);

  // Close mobile menu when clicking on a link
  const handleNavClick = () => {
    setIsMenuOpen(false);
  };

  return (
    <>
      {/* Animated Background */}
      <div className="animated-bg"></div>
      
      <nav className={`navbar navbar-expand-lg ${isScrolled ? 'scrolled' : ''} ${isScrolled ? 'stick-to-top' : ''}`}>
        <div className="container-fluid">
          {/* Logo Section */}
          <Link 
            className="navbar-brand" 
            to="/" 
            onClick={() => {
              handleScrollToTop();
              handleNavClick();
            }}
          >
            <span className="brand-text">POSlah!</span>
          </Link>

          {/* Navbar Toggler for Mobile */}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded={isMenuOpen}
            aria-label="Toggle navigation"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <div className="navbar-toggler-icon">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </button>

          {/* Navigation Links */}
          <div className={`collapse navbar-collapse ${isMenuOpen ? 'show' : ''}`} id="navbarNav">
            <ul className="navbar-nav me-auto">
              <li className="nav-item">
                <a 
                  className="nav-link" 
                  href="#features"
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavigateToSection('features');
                    handleNavClick();
                  }}
                >
                  Features
                </a>
              </li>
              <li className="nav-item">
                <a 
                  className="nav-link" 
                  href="#pricing"
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavigateToSection('pricing');
                    handleNavClick();
                  }}
                >
                  Pricing
                </a>
              </li>
              <li className="nav-item">
                <a 
                  className="nav-link" 
                  href="#reviews"
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavigateToSection('reviews');
                    handleNavClick();
                  }}
                >
                  What people say?
                </a>
              </li>
              <li className="nav-item">
                <Link 
                  className="nav-link" 
                  to="/insights"
                  onClick={() => {
                    handleScrollToTop();
                    handleNavClick();
                  }}
                >
                  Insights
                </Link>
              </li>
            </ul>
            
            {/* Action Buttons */}
            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <Link 
                  className="btn signin-btn" 
                  to="/signin"
                  onClick={handleNavClick}
                >
                  Sign In
                </Link>
              </li>
              <li className="nav-item">
                <Link 
                  className="btn request-demo-btn" 
                  to="/request-demo"
                  onClick={handleNavClick}
                >
                  Request A Demo
                </Link>
              </li>
              <li className="nav-item">
                <Link 
                  className="btn start-btn" 
                  to="/getstarted"
                  onClick={handleNavClick}
                >
                  Get Started
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Header;